document.addEventListener('DOMContentLoaded', function () {
  class MyElement extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({mode: 'open'});
    }

    connectedCallback() {
      this.render();
    }

    render() {
      this.shadowRoot.innerHTML = `
        <style>
          :host {
            display: block;
            padding: 10px;
            background-color: #f0f0f0;
            border: 1px solid #ddd;
          }
        </style>
        <div>
          <h2>My Custom Element</h2>
        </div>
      `;
    }
  }

  if (!window.customElements.get('my-element')) {
    customElements.define('my-element', MyElement);
  }

  // 创建 IntersectionObserver 实例
  window.YGImageLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        const newImg = new Image();
        newImg.onload = () => {
          img.src = newImg.src;
          img.removeAttribute('data-src');  // 如果只需要加载一次
          img.removeAttribute('srcset');
          observer.unobserve(img);          // 停止观察该元素
        }
        newImg.src = img.getAttribute('data-src');
      }
    });
  }, {
    rootMargin: "50px", // 预加载距离视口 50px 的图片
  });

  class YGImage extends HTMLElement {
    constructor() {
      super()
      this.init()
    }

    init() {
      // 这里放置初始化逻辑
      this.loaderImg()
    }

    get images() {
      return this.querySelectorAll('img[data-src]')
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        window.YGImageLoader.observe(img)
      })
    }
  }

  if (!window.customElements.get('yg-image')) {
    window.customElements.define('yg-image', YGImage)
  }

  class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.clickClosePopup = this.clickClosePopup.bind(this);
      this.clickOpenPopup = this.clickOpenPopup.bind(this);
      this.$contentInner = null;
    }

    connectedCallback() {
      this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
      this.addEventListener('click', this.clickClosePopup)
      document.addEventListener("YGPopup:open", this.clickOpenPopup)
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
    }

    clickOpenPopup(event) {
      const {$popupTemplate, fn} = event.detail;
      this.openPopup($popupTemplate, fn);
    }

    clickClosePopup(e) {
      this.closePopup(e, () => {
      });
    }

    openPopup($popupTemplate, fn) {
      // popupTemplate：需要替换的元素
      if (!$popupTemplate || !this.$contentInner) return;
      this.$contentInner.innerHTML = $popupTemplate.innerHTML;
      document.body.style.overflow = 'hidden';
      this.style.display = 'flex';
      typeof fn === 'function' && fn();
    }

    closePopup(e, fn) {
      let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
      if (closeClassName.some(className => e.target.classList.contains(className))) {
        this.style.display = 'none';
        this.$contentInner.innerHTML = '';
        document.body.style.overflow = 'auto';
        typeof fn === 'function' && fn();
      }
    }
  }

  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }

  class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this.itemClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
    }

    itemClick() {
      let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');

      console.log("$popupTemplate: ", $popupTemplate)
      if ($popupTemplate) {
        document.dispatchEvent(new CustomEvent("YGPopup:open", {
          bubbles: true,
          detail: {
            $popupTemplate,
            fn: () => {
            }
          }
        }))
      }
    }
  }

  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }

  class YGSlide extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.initSwiper()
    }

    initSwiper() {
      new Swiper(this, {
        pagination: {
          el: '.yg-slide-pagination',
          // 数字指示器
          // type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: this.querySelector('.yg-slide-next'),
          prevEl: this.querySelector('.yg-slide-prev'),
        },
        breakpoints: {
          220: {
            slidesPerView: 1.4,
            spaceBetween: 16,
          },
          700: {
            slidesPerView: 2,
            spaceBetween: 16,
          },
          1150: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }
      })
    }
  }

  if (!window.customElements.get('yg-slide')) {
    window.customElements.define('yg-slide', YGSlide)
  }

  class YGSecondaryMedia extends HTMLElement {
    constructor() {
      super();
      const prevElement = this.previousElementSibling;
      if (prevElement && prevElement.tagName === 'TEMPLATE') {
        const clone = prevElement.content.cloneNode(true);
        this.appendChild(clone);
      }
    }
  }

  if (!window.customElements.get('yg-secondary-media')) {
    customElements.define('yg-secondary-media', YGSecondaryMedia);
  }

  class YGSwitchInput extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick() {
      const productCard = this.closest('.product-card');
      const productHandle = productCard ? productCard.getAttribute('data-product-handle') : null;
      const switchId = this.getAttribute('data-switch-id');

      if (productHandle && switchId) {
        fetch(window.Shopify.routes.root + `products/${productHandle}.js`)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Failed to fetch product: ${response.statusText}`);
            }
            return response.json();
          })
          .then((product) => {
            const matchingVariant = product.variants.find(
              (variant) => variant.id.toString() === switchId
            );

            if (matchingVariant && matchingVariant.featured_image) {
              const image = matchingVariant.featured_image;
              const imageUrl = image.src;

              // 找到 yg-secondary-media
              const secondaryMedia = productCard.querySelector('yg-secondary-media');
              if (secondaryMedia) {
                // 如果 yg-secondary-media 后面是 <img>，先移除
                const nextImg = secondaryMedia.nextElementSibling;
                if (nextImg && nextImg.tagName === 'IMG') {
                  nextImg.remove();
                }

                // 创建新的 <img>
                const imgEl = document.createElement('img');
                imgEl.src = imageUrl.replace(/^https:/, ''); // Shopify 图片链接无协议
                imgEl.width = image.width;
                imgEl.height = image.height;
                imgEl.alt = product.title;
                imgEl.loading = 'lazy';
                imgEl.setAttribute('is', 'lazy-image');

                // 构建 srcset
                const widths = [180, 360, 540, 720, 900, 1080];
                const srcset = widths
                  .map(
                    (w) => `${imageUrl.replace(/^https:/, '')}&width=${w} ${w}w`
                  )
                  .join(', ');
                imgEl.srcset = srcset;

                // 插入到 yg-secondary-media 后面
                secondaryMedia.insertAdjacentElement('afterend', imgEl);
              }
            } else {
              console.warn('No matching variant or featured_image found');
            }
          })
          .catch((error) => {
            console.error("Error fetching product:", error);
          });
      }
    }
  }

  if (!window.customElements.get('yg-switch-input')) {
    customElements.define('yg-switch-input', YGSwitchInput);
  }


  // 独立工具函数
   function getCompareData() {
    return JSON.parse(sessionStorage.getItem('ProductCompareData')) || {products: []};
  }

  // 静态方法
  class CompareUtils {
    /**
     * 重置对比列表的占位符（清空现有内容并添加3个占位符）
     * @param {HTMLElement} compareList - 对比列表的DOM元素
     */
    static resetCompareListPlaceholders(compareList) {
      // 清空现有内容
      compareList.querySelectorAll(".yg-compare-product-box, .yg-compare-product-placeholder").forEach(el => el.remove());

      // 重新添加3个占位符
      for (let i = 0; i < 3; i++) {
        const placeholder = document.createElement('div');
        placeholder.className = 'yg-compare-product-placeholder';
        placeholder.textContent = window.compare_info?.placeholder_text || 'add product';
        compareList.appendChild(placeholder);
      }
    }
  }

  class YGProductCompare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.iconPlus = this.querySelector('#iconPlus');
      this.iconMinus = this.querySelector('#iconMinus');
      this.restoreCompareState();
      this.addEventListener('click', this.handleCompareToggle.bind(this));
    }

    restoreCompareState() {
      const compareData = getCompareData();
      const isActive = compareData.products.some(p => p.id === Number(this.dataset.productId));

      this.iconPlus.style.display = isActive ? 'none' : 'block';
      this.iconMinus.style.display = isActive ? 'block' : 'none';
      this.classList.toggle('active', isActive);

      this.updateButtonsAvailability();
    }

    handleCompareToggle() {
      const compareData = getCompareData();
      const isActive = !this.classList.contains('active');

      if (isActive && compareData.products.length >= 3) {
        this.showMaxLimitAlert();
        return;
      }

      const productData = this.getProductData();
      if (!productData) return;

      if (isActive) {
        compareData.products.push(productData);
      } else {
        compareData.products = compareData.products.filter(p => p.id !== productData.id);
      }
      sessionStorage.setItem('ProductCompareData', JSON.stringify(compareData));

      this.updateButtonUI(isActive);
      this.updateCompareBox(compareData);

      this.updateButtonsAvailability();
    }

    // ========== 下面是提取的公用方法 ==========

    // getCompareData() {
    //   return JSON.parse(sessionStorage.getItem('ProductCompareData')) || {products: []};
    // }

    getProductData() {
      const scriptEl = this.closest('.product-card-compare')?.querySelector('script[data-product-compare-data]');
      return scriptEl ? JSON.parse(scriptEl.textContent) : null;
    }

    updateButtonUI(isActive) {
      this.iconPlus.style.display = isActive ? 'none' : 'block';
      this.iconMinus.style.display = isActive ? 'block' : 'none';
      this.classList.toggle('active', isActive);
    }

    updateBoxState(hasProducts, compareBox) {
      compareBox.classList.toggle('active', hasProducts);

      const $button = compareBox.querySelector('.yg-toggle-button');
      if ($button) {
        $button.classList.toggle('active', hasProducts);
        $button.querySelector("#iconPlus").style.display = hasProducts ? 'none' : 'block';
        $button.querySelector("#iconMinus").style.display = hasProducts ? 'block' : 'none';

        const $toggleText = $button.querySelector('.toggle-text');
        if ($toggleText && window.compare_info) {
          $toggleText.textContent = hasProducts
            ? window.compare_info.expand_title
            : window.compare_info.compare_title;
        }
      }
    }

    updateCompareBox(compareData) {
      const compareBox = document.querySelector('yg-compare-box');
      if (!compareBox) return;

      compareBox.classList.add('active');
      const compareList = compareBox.querySelector(".yg-compare-product-list");
      if (!compareList) return;

      // 合并代码并清空新添加的产品信息及展位符
      CompareUtils.resetCompareListPlaceholders(compareList);

      compareData.products.forEach(product => {
        compareBox.updateCompareBox(product, true);
      });

      this.updateBoxState(compareData.products.length > 0, compareBox);

    }

    showMaxLimitAlert() {
      alert('Compare up to 3 items');
    }

    updateButtonsAvailability() {
      const compareData = getCompareData();
      const maxSelected = compareData.products.length >= 3;

      document.querySelectorAll('yg-product-compare').forEach(button => {
        const isActive = button.classList.contains('active');
        if (!isActive && maxSelected) {
          button.style.opacity = '0.5';
          button.style.pointerEvents = 'none';
        } else {
          button.style.opacity = '1';
          button.style.pointerEvents = 'auto';
        }
      });
    }
  }

  // if (!window.customElements.get('yg-product-compare')) {
  //   customElements.define('yg-product-compare', YGProductCompare);
  // }

  class YGCompareBox extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.toggleButton();
      this.restoreCompareBox();
      this.compareButtonHandler();
      this.setupRemoveButtons();
      this.removeAllData();
    }

    /**
     * 初始化展开/收起按钮
     */
    toggleButton() {
      this.button = this.querySelector('.yg-toggle-button');
      this.iconPlus = this.button.querySelector('#iconPlus');
      this.iconMinus = this.button.querySelector('#iconMinus');
      this.toggleText = this.button.querySelector('.toggle-text');

      this.button.addEventListener('click', () => {
        const isActive = this.button.classList.toggle('active');
        this.classList.toggle('active');

        this.iconPlus.style.display = isActive ? 'none' : 'block';
        this.iconMinus.style.display = isActive ? 'block' : 'none';

        if (this.toggleText && window.compare_info) {
          this.toggleText.textContent = isActive
            ? window.compare_info.expand_title
            : window.compare_info.compare_title;
        }
      });
    }

    /**
     * 初始化对比按钮（弹出对比弹窗）
     */
    compareButtonHandler() {
      const compareBtn = this.querySelector(".yg-compare-btn");
      const comparePopup = document.querySelector(".yg-compare-popup");

      compareBtn.addEventListener("click", () => {
        const compareData = JSON.parse(sessionStorage.getItem("ProductCompareData")) || {products: []};

        if (!compareData.products.length) {
          alert("No products to compare.");
          return;
        }

        comparePopup.updateAndShow(compareData);
      });
    }

    restoreCompareBox() {
      const compareData = JSON.parse(sessionStorage.getItem('ProductCompareData')) || {products: []};

      const hasProducts = compareData.products.length > 0;

      if (hasProducts) {
        this.classList.add('active');

        if (this.button) {
          this.button.classList.add('active');
          this.iconPlus.style.display = 'none';
          this.iconMinus.style.display = 'block';

          if (this.toggleText && window.compare_info) {
            this.toggleText.textContent = window.compare_info.expand_title;
          }
        }

      } else {
        this.classList.remove('active');

        if (this.button) {
          this.button.classList.remove('active');
          this.iconPlus.style.display = 'block';
          this.iconMinus.style.display = 'none';

          if (this.toggleText && window.compare_info) {
            this.toggleText.textContent = window.compare_info.compare_title;
          }
        }
      }

      compareData.products.forEach(product => {
        this.updateCompareBox(product, true);
      });
    }

    updateCompareBox(productData, isRestoring = false) {
      const compareList = this.querySelector('.yg-compare-product-list');
      const placeholders = compareList ? compareList.querySelectorAll('.yg-compare-product-placeholder') : [];

      if (!compareList || placeholders.length === 0) {
        console.warn('No compare list or placeholders found.');
        return;
      }

      const availablePlaceholder = Array.from(placeholders).find(placeholder => placeholder.style.display !== 'none');

      if (!availablePlaceholder) {
        console.warn('No available placeholders to replace.');
        return;
      }

      const template = compareList.querySelector('#yg-compare-product-template');
      const clone = template.content.cloneNode(true);

      const compareProductBox = clone.querySelector('.yg-compare-product-box');
      const compareProductInfo = compareProductBox.querySelector('.yg-compare-product-info');
      const compareProductTitle = compareProductInfo.querySelector('.yg-compare-product-title');
      const compareProductDes = compareProductInfo.querySelector('.yg-compare-product-des');
      const compareProductData = compareProductInfo.querySelector('.yg-compare-product-data');
      const compareProductImage = compareProductBox.querySelector('img');

      compareProductBox.setAttribute('data-id', productData.id);
      compareProductBox.setAttribute('data-compare-handle', productData.handle);

      compareProductTitle.href = `/products/${productData.handle}`;
      compareProductTitle.textContent = productData.title;
      compareProductDes.innerHTML = productData.description || '';
      compareProductData.textContent = productData.data || '';
      compareProductImage.src = productData.image || '';

      if (availablePlaceholder) {
        availablePlaceholder.style.display = 'none';
      }
      availablePlaceholder.replaceWith(compareProductBox);

      if (!isRestoring) {
        compareList.appendChild(clone);
      }
    }

    /**
     * 监听删除按钮点击（事件委托）
     */
    setupRemoveButtons() {
      this.addEventListener('click', (event) => {
        const removeButton = event.target.closest('.compare-remove');
        if (!removeButton) return;

        const productBox = removeButton.closest('.yg-compare-product-box');
        if (!productBox) return;

        const productId = Number(productBox.dataset.id);
        this.removeProduct(productId);
      });
    }

    /**
     * 删除所有数据
     */
    removeAllData() {
      this.clearButton = this.querySelector('.yg-compare-clear');
      this.clearButton.addEventListener('click', () => {
        sessionStorage.setItem('ProductCompareData', JSON.stringify({products: []}));
        const compareList = this.querySelector('.yg-compare-product-list');
        if (!compareList) return;

        // 合并代码并清空新添加的产品信息及展位符
        CompareUtils.resetCompareListPlaceholders(compareList);

        // 更新对比栏展开状态
        this.updateBoxState(false);

        // 同步所有对比按钮状态
        this.updateAllCompareButtons();
      })
    }

    /**
     * 从缓存和UI中移除指定商品
     * @param {number} productId - 要移除的商品ID
     */
    removeProduct(productId) {
      // 从缓存删除数据
      const compareData = getCompareData();
      compareData.products = compareData.products.filter(p => p.id !== productId);
      sessionStorage.setItem('ProductCompareData', JSON.stringify(compareData));
      //  更新UI
      this.updateCompareBoxUI();

      //  同步所有对比按钮状态
      this.updateAllCompareButtons();
    }

    updateCompareBoxUI() {
      const compareData = getCompareData();
      const compareList = this.querySelector('.yg-compare-product-list');

      // 合并代码并清空新添加的产品信息及展位符
      CompareUtils.resetCompareListPlaceholders(compareList);
      // 重新渲染商品
      compareData.products.forEach(product => {
        this.updateCompareBox(product, true);
      });

      // 更新对比栏展开状态
      this.updateBoxState(compareData.products.length > 0);
    }

    // 更新盒子状态
    updateBoxState(hasProducts) {
      // 如果有产品，则添加active类，否则移除active类
      this.classList.toggle('active', hasProducts);

      // 如果有按钮
      if (this.button) {
        // 如果有产品，则添加active类，否则移除active类
        this.button.classList.toggle('active', hasProducts);
        // 如果有产品，则隐藏加号图标，否则显示加号图标
        this.iconPlus.style.display = hasProducts ? 'none' : 'block';
        // 如果有产品，则显示减号图标，否则隐藏减号图标
        this.iconMinus.style.display = hasProducts ? 'block' : 'none';

        // 如果有切换文本，并且有比较信息
        if (this.toggleText && window.compare_info) {
          // 如果有产品，则显示展开标题，否则显示比较标题
          this.toggleText.textContent = hasProducts
            ? window.compare_info.expand_title
            : window.compare_info.compare_title;
        }
      }
    }

    updateAllCompareButtons() {
      document.querySelectorAll('yg-product-compare').forEach(button => {
        button.restoreCompareState();
      });
    }
  }

  // if (!window.customElements.get('yg-compare-box')) {
  //   customElements.define('yg-compare-box', YGCompareBox);
  // }

  class YGComparePopup extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.template = this.querySelector("template");
      this.compareContainer = this.querySelector(".yg-compare-card-items");
      this.compareTable = this.querySelector(".yg-compare-product-table");
      if (!this.template || !this.compareContainer) {
        console.error('Template or compare container not found.');
      }

      this.hide = this.hide.bind(this);
      this.clearDynamicContent = this.clearDynamicContent.bind(this);
      this.removeButton = this.querySelector('.yg-compare-product-remove');

      if (this.removeButton) {
        this.removeButton.addEventListener('click', this.hide);
      }
    }

    clearDynamicContent() {
      // 清除产品卡片（只删除动态生成的卡片）
      if (this.compareContainer) {
        const dynamicCards = this.compareContainer.querySelectorAll('[data-product-id]');
        dynamicCards.forEach(card => card.remove());
      }

      // 清除价格、评论、变体的动态内容（保留template和标题）
      const containers = [
        ".yg-compare-price-items",
        ".yg-compare-review-items",
        ".yg-compare-variant-items"
      ];

      containers.forEach(selector => {
        const container = this.querySelector(selector);
        if (!container) return;

        // 只删除特定类名的动态内容（保留template和标题）
        const dynamicItems = container.querySelectorAll(`
        .yg-compare-price-item:not(template),
        .yg-compare-review-item:not(template),
        .yg-compare-variant-item:not(template)
      `);
        dynamicItems.forEach(item => item.remove());
      });
    }

    fillCompareData(compareData) {
      const priceContainer = this.querySelector(".yg-compare-price-items");
      const reviewContainer = this.querySelector(".yg-compare-review-items");
      const variantContainer = this.querySelector(".yg-compare-variant-items");

      const priceTemplate = priceContainer.querySelector("template");
      const reviewTemplate = reviewContainer.querySelector("template");
      const variantTemplate = variantContainer.querySelector("template");

      compareData.products.forEach(product => {
        const productTemplate = this.template.content.cloneNode(true);
        const productElement = productTemplate.querySelector(".yg-compare-card-item");

        productElement.setAttribute("data-product-id", product.id);
        productElement.querySelector(".yg-compare-card-image img").src = product.image || "";
        productElement.querySelector(".yg-compare-card-title").innerText = product.title || "";
        productElement.querySelector(".yg-compare-card-des").innerHTML = product.description || "";
        productElement.querySelector(".yg-compare-card-data").innerText = product.data || "";

        const availabilityElement = productElement.querySelector(".yg-compare-card-availability");
        if (product.available) {
          availabilityElement.innerHTML = `Availability <span class="in-stock">In Stock</span>`;
        } else {
          availabilityElement.innerHTML = `<span class="out-of-stock">Out of Stock</span>`;
        }

        this.compareContainer.appendChild(productElement);

        // ------- 价格 -------
        const priceEl = priceTemplate.content.cloneNode(true).querySelector(".yg-compare-price-item");
        priceEl.setAttribute("data-product-id", product.id);
        priceEl.innerText = product.price ? `$${(Number(product.price) / 100).toFixed(2)}` : "-";
        priceContainer.appendChild(priceEl);

        // ------- 评论数量 -------
        const reviewEl = reviewTemplate.content.cloneNode(true).querySelector(".yg-compare-review-item");
        reviewEl.setAttribute("data-product-id", product.id);
        reviewEl.innerText = product.reviewCount || "0";
        const ratingContainer = document.createElement('div');
        ratingContainer.className = 'yg-compare-rating-container';
        // 创建星星评分容器
        const starsContainer = document.createElement('div');
        starsContainer.className = 'yg-compare-stars';

        const rating = Math.min(5, Math.max(0, product.reviewRate || 0)); // 确保在0-5之间
        const reviewNumber = product.reviewCount;
        console.log("reviewNumber: ", reviewNumber)
        const filledStars = rating;
        const emptyStars = 5 - rating;

        for (let i = 0; i < filledStars; i++) {
          const star = document.createElement('span');
          star.className = 'star filled';
          star.innerHTML = '★'; // 实心星星
          starsContainer.appendChild(star);
        }

        for (let i = 0; i < emptyStars; i++) {
          const star = document.createElement('span');
          star.className = 'star empty';
          star.innerHTML = '☆'; // 空心星星
          starsContainer.appendChild(star);
        }

        const countSpan = document.createElement('span');
        countSpan.className = 'review-count';
        countSpan.textContent = ` (${product.reviewCount || 0})`;
        countSpan.className = 'review-count';
        countSpan.textContent = ` (${product.reviewCount || 0})`; // 显示格式如"(123)"

        ratingContainer.appendChild(starsContainer);
        ratingContainer.appendChild(countSpan);

        reviewEl.innerHTML = '';
        reviewEl.appendChild(ratingContainer);
        reviewContainer.appendChild(reviewEl);

        // 新的自定义数据
        if (product.otherData && product.otherData.length > 0) {
          const existingRows = this.compareTable.querySelectorAll('.yg-compare-data-items');
          existingRows.forEach(row => row.remove());

          const allTitles = [];
          compareData.products.forEach(product => {
            if (product.otherData && product.otherData.length > 0) {
              product.otherData.forEach(dataItem => {
                const cleanTitle = dataItem.title.replace('<br />', '').trim();
                if (!allTitles.includes(cleanTitle)) {
                  allTitles.push(cleanTitle);
                }
              });
            }
          });

          allTitles.forEach(title => {
            const itemContainer = document.createElement('div');
            itemContainer.className = 'yg-compare-product-items yg-compare-data-items';

            const titleElement = document.createElement('div');
            titleElement.className = 'yg-compare-item-title';
            titleElement.textContent = title;
            itemContainer.appendChild(titleElement);

            // 为每个产品添加对应的值
            compareData.products.forEach(product => {
              const valueElement = document.createElement('div');
              valueElement.className = 'yg-compare-data-item';
              valueElement.setAttribute("data-product-id", product.id);

              // 查找匹配的数据
              const matchingData = product.otherData?.find(
                item => item.title.replace('<br />', '').trim() === title
              );

              valueElement.textContent = matchingData?.value || "-";
              itemContainer.appendChild(valueElement);
            });

            this.compareTable.appendChild(itemContainer);
          });
        }

        // ------- 颜色变体 -------
        const variantName = variantContainer.querySelector(".yg-compare-item-title");
        const colorVariant = product.variants?.find(variant => variant.name === "Color");

        const variantEl = variantTemplate.content.cloneNode(true).querySelector(".yg-compare-variant-item");
        variantEl.setAttribute("data-product-id", product.id);
        variantEl.innerHTML = '';

        if (colorVariant && colorVariant.values.length > 0) {
          colorVariant.values.forEach(color => {
            const colorSpan = document.createElement('span');
            colorSpan.className = 'color-variant';
            // colorSpan.textContent = color;

            const matchingLabels = this.getMatchingSwatchLabels(product.id, color);
            if (matchingLabels.length > 0) {
              const firstLabel = matchingLabels[0];
              const computedStyle = window.getComputedStyle(firstLabel);

              colorSpan.style.setProperty('--swatch-background',
                computedStyle.getPropertyValue('--swatch-background').trim());
              colorSpan.style.setProperty('--swatch-border',
                computedStyle.getPropertyValue('--swatch-border').trim());
            } else {
              colorSpan.textContent = color;
              colorSpan.style.fontSize = '0.75rem';
            }
            variantEl.appendChild(colorSpan);

          });
        } else {
          variantEl.innerHTML = '<span class="no-variant">-</span>';
        }

        variantContainer.appendChild(variantEl);

        if (!variantName.innerText.trim()) {
          variantName.innerText = colorVariant?.name || "Color";
        }

        const removeButton = productElement.querySelector(".yg-compare-card-remove");
        if (removeButton) {
          removeButton.addEventListener('click', () => {
            this.removeProduct(product.id);
          });
        }
      });
    }

    getMatchingSwatchLabels(productId, colorValue) {
      const matches = [];
      const productCompares = document.querySelectorAll(`yg-product-compare[data-product-id="${productId}"]`);

      productCompares.forEach(compareEl => {
        const productCard = compareEl.closest('.product-card.product-card-compare');
        if (!productCard) return;

        const labels = productCard.querySelectorAll('.product-card__swatch-list label');
        labels.forEach(label => {
          const span = label.querySelector('span');
          if (span && span.textContent.trim() === colorValue.trim()) {
            matches.push(label);
          }
        });
      });

      return matches;
    }

    show() {
      this.classList.add("active");
    }

    hide() {
      this.classList.remove("active");
      this.clearDynamicContent();
    }

    updateAndShow(compareData) {
      this.clearDynamicContent();
      this.show();
      this.fillCompareData(compareData);
      this.addToCart()
    }

    removeProduct(productId) {
      // 删除对应的缓存数据
      const compareData = getCompareData();
      compareData.products = compareData.products.filter(p => p.id !== productId);
      sessionStorage.setItem('ProductCompareData', JSON.stringify(compareData));

      // 删除产品卡片
      const card = this.querySelector(`.yg-compare-card-item[data-product-id="${productId}"]`);
      if (card) card.remove();

      // 删除其他关联属性
      const selectors = [
        `.yg-compare-price-item[data-product-id="${productId}"]`,
        `.yg-compare-review-item[data-product-id="${productId}"]`,
        `.yg-compare-variant-item[data-product-id="${productId}"]`
      ];

      selectors.forEach(selector => {
        const element = this.querySelector(selector);
        if (element) element.remove();
      });

      const dataItems = this.querySelectorAll(`.yg-compare-data-item[data-product-id="${productId}"]`);
      dataItems.forEach(item => item.remove());

      //  删除底部懒对应的产品卡片
      const compareBox = document.querySelector('yg-compare-box');
      if (!compareBox) return;

      const compareList = compareBox.querySelector('.yg-compare-product-list');
      if (!compareList) return;

      // 合并代码并清空新添加的产品信息及展位符
      CompareUtils.resetCompareListPlaceholders(compareList);

      // 重新渲染商品
      compareData.products.forEach(product => {
        compareBox.updateCompareBox(product, true);
      });

      // 更新对比栏展开状态
      compareBox.updateBoxState(compareData.products.length > 0);

      // 同步所有对比按钮状态
      compareBox.updateAllCompareButtons();
    }

    addToCart() {
      this.cardButton = this.querySelectorAll(".yg-compare-card-item .yg-compare-card-button");
      this.cardButton.forEach((button) => {
        button.addEventListener('click', async (e) => {
          e.preventDefault();
          const productItem = e.target.closest(".yg-compare-card-item");
          const productId = productItem.getAttribute("data-product-id");
          let sectionsToBundle = ["variant-added"];
          document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
            bubbles: true,
            detail: {sections: sectionsToBundle}
          }));

          const formData = new FormData(button.closest('form'));
          formData.set("id", productId)
          formData.set("sections", sectionsToBundle.join(","));
          formData.set("sections_url", `${Shopify.routes.root}variants/${productId}`);

          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            body: formData,
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          const responseJson = await response.json();
          if (response.ok) {
            if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
              return window.location.href = `${Shopify.routes.root}cart`;
            }
            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent["sections"] = responseJson["sections"];
            this.dispatchEvent(new CustomEvent("variant:add", {
              bubbles: true,
              detail: {
                items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
                cart: cartContent
              }
            }));
            document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
              bubbles: true,
              detail: {
                baseEvent: "variant:add",
                cart: cartContent
              }
            }));
          } else {
            this.dispatchEvent(new CustomEvent("cart:error", {
              bubbles: true,
              detail: {
                error: responseJson["description"]
              }
            }));
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }

        })
      })
    }
  }

  // if (!window.customElements.get('yg-compare-popup')) {
  //   customElements.define('yg-compare-popup', YGComparePopup);
  // }
});

